import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        level: '='
    },
    template: `
        <div class="heading01 type01">
            <a ui-sref="authorized.user.group.list.level()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
            <h1>{{ vm.level.value }}</h1>
        </div>
        <user-group-form-level form="vm.form" level="vm.level"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.level, model => model.$update({ id: model.id }));
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/detail/level/index.js